const siteTitle = 'Lopeta tilauksesi';

export default {
  mainTexts: {
    siteTitle: `${siteTitle}`,
    formTitle1: 'Täytä tietosi',
    formTitle2: 'Maksat täällä',
    btnForm: 'Jatka',
    btnForm2: 'Maksa',
    priceText1: 'Maksu',
    priceText2: 'Yhteensä',
    footerTitle: 'Verkkomaksu',
    footerText: 'Vahvista luottokortillasi',
  },
  home: {
    placeholder: {
      firstName: 'Etunimi',
      lastName: 'sukunimi',
      email: 'sähköpostiosoite',
      phone: 'puhelin',
      city: 'Kaupunki',
      address: 'Osoite',
      zip: 'postinumero',
      continue: 'Jatka',
      name: 'Nome',
    },
    cardNumber: 'kortin numero',
    expirationDate: 'viimeinen käyttöpäivä',
    name: 'etunimi',
    month: 'kuukauden',
    year: 'vuoden',
    cvv: 'CVV',
    confirmPayment: 'Vahvista maksu',
  },
  validation: {
    requireEmail: 'Sähköpostiosoitteesi on tyhjä',
    validEmail: 'Sähköposti on virheellinen',
    requirePhone: 'Puhelimesi on tyhjä',
    minPhone: 'Puhelinkentässä on oltava vähintään 10 merkkiä.',
    requireFirstName: 'Etunimi vaaditaan.',
    validFirstName: 'Etunimi on virheellinen.',
    requireLastName: 'Sukunimi-kenttä vaaditaan.',
    validLastName: 'Sukunimi-kenttä ei kelpaa.',
    requireCity: 'Illallisravintola.',
    validCity: 'Kaupunkikenttä on virheellinen.',
    requireAddress: 'Osoitekenttä vaaditaan.',
    validAddress: 'Osoitekenttä on virheellinen.',
    requireZip: 'Postinumerokentti vaaditaan.',
    validZip: 'Zip-kenttä ei kelpaa.',
    requireCard: 'Kortin numerokenttä vaaditaan.',
    minCard: 'Ei tarpeeksi symboleja.',
    validCard: 'Kortin numerokenttä on virheellinen.',
    requireMonth: 'Viimeinen käyttökentäkenttä vaaditaan.',
    requireYear: 'Viimeinen käyttökenttä vaaditaan.',
    requireName: 'Nimiä vastaava kenttä on täytettävä.',
    validName: 'Nimikenttä ei kelpaa.',
    requireCvv: 'CVV-kenttä vaaditaan.',
    validCvv: 'CVV-kenttä ei ole kelvollinen.',
    minFirstName: 'Etunimikentän on oltava vähintään 3 merkkiä pitkä.',
    minLastName: 'Sukunimikentän on oltava vähintään 3 merkkiä pitkä.',
    minCity: 'Kaupunkikentän tulee sisältää vähintään 3 merkkiä.',
    minAddress: 'Osoitekentän on oltava vähintään 3 merkkiä pitkä.',
    minZip: 'Postinumero-kentässä on oltava vähintään 3 merkkiä.',
    minName: 'Nimikentän on oltava vähintään 3 merkkiä pitkä.',
    minCvv: 'CVV-kentässä on oltava vähintään 3 merkkiä.',
    specialFirstName: 'Etunimi-kenttä ei saa sisältää erikoismerkkejä',
    specialLastName: 'Ohjaimen sukunimi ei saa sisältää erikoismerkkejä',
    specialName: 'Kentän nimi ei saa sisältää erikoismerkkejä',
    specialCity: 'Maassa sijaitsevassa kaupungissa ei saa olla erikoismerkkejä',
  },
  mask: {
    phone: '+359 99 999 9999',
    zip: '99999',
    creditCard: '9999 9999 9999 9999',
    cvv: '9999',
  },
  getInTouch: {
    title: 'Ota yhteyttä',
    firstName: 'Etunimi',
    lastName: 'sukunimi',
    email: 'sähköposti',
    msg: 'Viesti',
    send: 'Lähetä',
    alreadyRegistered: 'Olet jo rekisteröitynyt',
    unsubscribeLink: 'unsubscribe link',
    worktime: 'Puhelinkeskus toimii 10: stä 17: een',
    phone: 'Puhelin: Sofia +359 2 437 4207',
  },
};
